module.exports = __webpack_public_path__ + "static/work-63858c615d14c2e77560eac0bf08fff3.jpg";